var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JadeBox',{attrs:{"hasPadding":""}},[_c('div',{staticClass:"mb-4"},[_c('JadeText',{attrs:{"variant":"heading-xsmall"}},[_vm._v(" "+_vm._s(_vm.$t('progress'))+" ")])],1),_c('JadeStatusTracker',{attrs:{"direction":"vertical","items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }